'use client';

import { useState } from 'react';
import classNames from 'classnames';
import { Button } from '@/features/button';
import SafeHtml from '@/components/safe-html';
import { IconArrowSquareLeft } from '@/components/svg-symbols/icons';
import { SHOW_MORE_BUTTON_CHARACTER_LIMIT } from '@/app/(plp)/constants';
import { PUBLIC_IS_BOT } from '@/app/_constants/search-engines';
import '@/assets/styles/quill.snow.css';
import { getPLPSEODescription } from '../_utils/get-plp-seo-description';
import { useBasicMetas } from '../_utils/use-basic-metas';
import { usePLPFacetsContext } from '../facets-context/facets-context';
function SEODescription() {
  const {
    page
  } = usePLPFacetsContext();
  const basicMetas = useBasicMetas().basicMetas;
  const seoDescription = basicMetas ? getPLPSEODescription(page, basicMetas) : undefined;
  const [isVisible, setIsVisible] = useState(PUBLIC_IS_BOT || seoDescription?.length && seoDescription?.length < SHOW_MORE_BUTTON_CHARACTER_LIMIT);
  if (!seoDescription) return null;
  const handleToggleIsVisible = () => setIsVisible(prev => !prev);
  return <div className='mt-4 flex w-full flex-col items-end justify-between gap-1 rounded-md px-2 text-justify lg:col-span-9 lg:col-start-4 lg:mt-6' data-sentry-component="SEODescription" data-sentry-source-file="seo-description.tsx">
            <div data-test='plp-seo-description' className={classNames('relative w-full overflow-hidden whitespace-normal', {
      'max-h-[88px] lg:max-h-24': !isVisible
    })}>
                <SafeHtml content={seoDescription} className='ql-editor text-body-14 text-text-darkGray [&>h2]:mb-1 [&>h2]:font-bold [&>h3]:mb-1 [&>h3]:font-bold [&_a]:font-bold [&_a]:text-[#DB2777] [&_a]:no-underline hover:[&_a]:underline' data-sentry-element="SafeHtml" data-sentry-source-file="seo-description.tsx" />

                <div className={classNames('absolute bottom-0 right-0 h-full w-full bg-gradient-to-t from-white', {
        hidden: isVisible
      })} />
            </div>

            <Button size='small' graphicStyle='text' icon={{
      position: 'left',
      element: <IconArrowSquareLeft className='h-6 w-6' />
    }} onClick={handleToggleIsVisible} data-sentry-element="Button" data-sentry-source-file="seo-description.tsx">
                {isVisible ? 'بستن' : 'مشاهده بیشتر'}
            </Button>
        </div>;
}
export default SEODescription;